import { render } from "./FormsPage.vue?vue&type=template&id=8d9fd978"
import script from "./FormsPage.vue?vue&type=script&lang=js"
export * from "./FormsPage.vue?vue&type=script&lang=js"

import "./FormsPage.vue?vue&type=style&index=0&id=8d9fd978&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__